var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadphonesBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4C6.68629 4 4 6.68629 4 10V11H5C6.10457 11 7 11.8954 7 13V16C7 17.1046 6.10457 18 5 18H4C2.89543 18 2 17.1046 2 16V15V13V10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10V13V15V16C18 17.1046 17.1046 18 16 18H15C13.8954 18 13 17.1046 13 16V13C13 11.8954 13.8954 11 15 11H16V10C16 6.68629 13.3137 4 10 4Z",
    fill: "#111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphonesBlack);
export default __webpack_public_path__ + "static/media/headphones-black.1646f5b60391e7567bfe5d835170b9fd.svg";
export { ForwardRef as ReactComponent };